<ng-container *ngIf="isOpen">
  <section class="snack-bar-root" [attr.data-successful]="snackBarSuccessful" [attr.data-warn]="snackBarWarn">
    <span class="text">{{snackMessage}}</span>
    <button (click)="closeSnackBar()">✕</button>
  </section>
</ng-container>